const modePicker = document.getElementById('mode-picker');
const mode = localStorage.getItem('mode');

modePicker.addEventListener('change', (c) => {
  localStorage.setItem('mode', modePicker.value);
})

modePicker.value = mode ? mode : 'auto';
